import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import rootReducer from './reducers/index';

const persistConfig = {
	key: 'root',
	storage,
	blacklist: ['products', 'alert', 'adminProducts'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
	persistedReducer,
	applyMiddleware(thunk)
);

const persistor = persistStore(store);

export { store, persistor };
